import { defineRecipe } from '@chakra-ui/react/styled-system';

const definitionTooltipRecipe = defineRecipe({
  className: 'definition-tooltip',
  base: {
    color: 'inherit',
    font: 'inherit',
    letterSpacing: 'inherit',
    maxWidth: '100%',
    textDecoration: 'underline dotted',
    textDecorationColor: 'color/neutral/bold',
    textUnderlineOffset: '0.375em',
    '&:hover': {
      textDecorationColor: 'color/purple/base',
    },
  },
  variants: {
    method: {
      click: {
        cursor: 'pointer',
      },
      hover: {
        cursor: 'default',
      },
    },
    textSize: {
      lg: { textStyle: 'body/lg/regular' },
      md: { textStyle: 'body/md/regular', textUnderlineOffset: '0.25em' },
      sm: { textStyle: 'body/sm/regular', textUnderlineOffset: '0.25em' },
    },
  },
  defaultVariants: {
    textSize: 'lg',
  },
});

export default definitionTooltipRecipe;
